import { ICommonSettings, IElasticApmSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigElasticApmSettings, ELASTIC_APM_SETTINGS_SEARCH_TERMS } from "./app-settings-config-elastic-apm";

export interface IConfigElasticApmInputState {
  showModal: boolean;
  editingElasticApmId: string;
}

export interface IConfigElasticApmInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigElasticApmInput extends PureComponent<IConfigElasticApmInputProps, IConfigElasticApmInputState> {
  formInputName = ["apiConfig", "elasticApmSettingsId"];

  constructor(props: IConfigElasticApmInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingElasticApmId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingElasticApmId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingElasticApmId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const options = [
      { id: null, name: "None" } as unknown as IElasticApmSetting,
      ...(this.props.commonSettings.elasticApmSettings || [])
    ];
    return (
      <>
        <ConfigElasticApmSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingElasticApmId={this.state.editingElasticApmId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          searchTerms={ELASTIC_APM_SETTINGS_SEARCH_TERMS}
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="appsettings_elasticapmsettings_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsElasticApmDropdown"
          addNewTestId="appSettingsElasticApmAddNewButton"
          editTestId="appSettingsElasticApmEditButton"
        />
      </>
    );
  }
}
